// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5789a1cd","821":"e7a692b4"}[chunkId] + ".chunk.js";
};